import {
    Card, CardContent, Container,
    Link, Stack, TextField, Typography,
    useMediaQuery, Switch
}
    from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { apiInstance } from 'src/utils/apiAuth';
import { showErrorToast, showToast } from 'src/utils/Toast/SnackbarProvider';
import Page from 'src/components/Page';


export default function AddCMDForm() {
    const id = useParams();
    const hrToken = localStorage.getItem("authToken");
    const navigate = useNavigate();

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    const [cmdInfo, setCMDInfo] = useState([]);
    const getCMDInfo = () => {
        apiInstance({
            method: "get",
            url: "company-member-designation/" + id.id,
            headers: {
                Authorization: "token " + hrToken,
            }
        })
            .then(function (response) {
                setCMDInfo(response?.data?.data);
            })
            .catch(function (error) {
                showErrorToast(error);
            });
    }

    useEffect(() => {
        if (id?.id) getCMDInfo();
    }, [id, id?.id])

    const callAddCMDAPI = (formValues) => {
        apiInstance({
            method: "post",
            url: "company-member-designation/",
            headers: {
                Authorization: "token " + hrToken,
            },
            data: formValues,
        })
            .then(function (response) {
                showToast(response.data.message)
                navigate("/cmd", { replace: true });
            })
            .catch(function (error) {
                showErrorToast(error);
                setSubmitting(false)
            });
    }

    const callEditCMDAPI = (formValues) => {
        apiInstance({
            method: "put",
            url: "company-member-designation/" + id.id + "/",
            data: formValues,
        })
            .then(function (response) {
                showToast(response.data.message);
                navigate("/cmd", { replace: true });
            })
            .catch(function (error) {
                showErrorToast(error);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (id && cmdInfo) {
            formik.setValues({
                label: cmdInfo?.label || '',
                order: cmdInfo?.order || '',
                is_active: cmdInfo?.is_active || false,
            });
        }
    }, [id, cmdInfo]);

    const Schema = Yup.object().shape({
        label: Yup.string()
            .required("Comany Member Designation required"),
        order: Yup.number()
            .required("Order required."),
        is_active: Yup.string()
            .required("Active status is required."),
    });

    const formik = useFormik({
        initialValues: {
            label: '',
            order: '',
            is_active: false,
        },
        validationSchema: Schema,
        onSubmit: (values) => {
            let formData = {
                "label": values.label,
                "name": (values.label).toUpperCase(),
                "order": values.order,
                "is_active": values.is_active,
            }
            if (id?.id) {
                callEditCMDAPI(formData)
            } else {
                callAddCMDAPI(formData)
            }
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setSubmitting, setFieldValue, handleChange } = formik;

    return (
        <Page title="Add Company Member Designation">
            <Container maxWidth="xl">
                <Stack direction="row" sx={{ mb: 2, justifyContent: "space-between", alignItems: "center" }}>
                    <Link to="/cmd" color="green" underline="hover" component={RouterLink} fontSize="20px">
                        <ArrowCircleLeftIcon fontSize="large" />
                    </Link>
                    <Typography variant="h4" sx={{ my: matches ? 0 : 5 }} align="center" color="black">
                        {id?.id ? "Update Company Member Designation" : "Add Company Member Designation"}
                    </Typography>
                    <div></div>
                </Stack>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <Card sx={{ mt: 2, marginInline: 'auto' }} variant="outlined" style={{ width: matches ? '70%' : '50%' }}>
                            <CardContent>
                                <Stack spacing={3}>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            label="Company Memeber Designation Name"
                                            {...getFieldProps('label')}
                                            error={Boolean(touched.label && errors.label)}
                                            helperText={touched.label && errors.label}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            type='number'
                                            label="Order"
                                            {...getFieldProps('order')}
                                            error={Boolean(touched.order && errors.order)}
                                            helperText={touched.order && errors.order}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack>
                                        <div role="group" style={{ width: '40%' }}>
                                            <Stack
                                                direction={{ xs: "column", sm: "row" }}
                                                spacing={3}
                                                style={{ padding: "20px 0 0 12px" }}
                                            >
                                                <div id="switch-label" style={{ color: '#637381', marginTop: '5px' }}> Is Active? </div>
                                                <Switch
                                                    name="is_active"
                                                    checked={values.is_active}
                                                    onChange={(event, checked) => {
                                                        setFieldValue("is_active", checked);
                                                    }}
                                                />
                                            </Stack>
                                            <ErrorMessage name="is_active">
                                                {(msg) => <span style={{ color: "#FF4842", fontSize: "12px", marginLeft: 15 }}>{msg}</span>}
                                            </ErrorMessage>
                                        </div>
                                    </Stack>
                                </Stack>

                            </CardContent>
                        </Card>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} />
                        <LoadingButton
                            size="large"
                            type="submit"
                            variant="contained"
                            loading={isSubmitting}
                            style={{ display: "block", margin: "auto", width: 400 }}
                        >
                            Add Company Member Designation
                        </LoadingButton>
                    </Form>
                </FormikProvider>
            </Container>
        </Page >
    )
}